import {
  LoadChatMedia,
  LoadMorePaidMessagesAction,
  PaidState,
  SetMediaMessages,
  SetMorePaidMessagesAction,
  SetPaidMessagesAction,
} from '$store/paid/interface';
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '$store/rootReducer';
import { MessageModel, PaidMessageModel, UserModel } from '$store/models';

const initialState: PaidState = {
  messages: [],
  media: null,
  isMediaLoading: true,
  isMessagesLoading: true,
  isMoreMessagesLoading: false,
  nextFrom: 0,
};

const paidMessagesMapper = (
  purchases: MessageModel[],
  users: { [id: number]: UserModel },
): PaidMessageModel[] => {
  return purchases.map((purchase) => {
    const { photo, firstName, lastName } = users[purchase.fromId];

    return {
      ...purchase,
      userPhoto: photo,
      userName: `${firstName} ${lastName}`,
    };
  });
};

export const { actions, reducer } = createSlice({
  name: 'paid',
  initialState,
  reducers: {
    loadMediaMessages(state, action: LoadChatMedia) {
      state.isMediaLoading = true;
    },
    loadPaidMessages(state) {
      state.isMessagesLoading = true;
    },
    setPaidMessages(state, action: SetPaidMessagesAction) {
      const { purchases, users, nextFrom } = action.payload;

      state.messages = paidMessagesMapper(purchases, users);
      state.isMessagesLoading = false;
      state.nextFrom = nextFrom;
    },
    setMediaMessages(state, action: SetMediaMessages) {
      state.media = action.payload;
      state.isMediaLoading = false;
    },
    setMorePaidMessages(state, action: SetMorePaidMessagesAction) {
      const { purchases, users, nextFrom } = action.payload;

      state.messages.push(...paidMessagesMapper(purchases, users));
      state.isMoreMessagesLoading = false;
      state.nextFrom = nextFrom;
    },
    loadMorePaidMessages(state, action: LoadMorePaidMessagesAction) {
      state.isMoreMessagesLoading = true;
    },
  },
});

export { reducer as paidReducer, actions as paidActions };

export const paidSelector = (state: RootState) => state.paid;
